"use client";

/**
 * @contract
 *   Назначение: Кнопка копирования текста в буфер обмена
 *   Автор:      AI Agent (Фаза A')
 *   Дата:       2026-03-17
 */

import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

interface CopyButtonProps {
  text: string;
  className?: string;
}

export function CopyButton({ text, className = "" }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`inline-flex items-center justify-center w-5 h-5 rounded-none hover:bg-[hsl(var(--portal-surface-2))] transition-colors ${className}`}
      title="Скопировать"
      aria-label="Скопировать"
    >
      {copied ? (
        <Check className="w-3 h-3 text-[hsl(var(--portal-accent))]" />
      ) : (
        <Copy className="w-3 h-3 text-[hsl(var(--portal-text-dim))] hover:text-[hsl(var(--portal-text-secondary))]" />
      )}
    </button>
  );
}
